module.exports = __webpack_public_path__ + "img/block.528094a7.svg";